var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{attrs:{"name":"header"}}),(_vm.loading)?_c('spinner',{attrs:{"with-overlay":"","large":"","active":""}}):(_vm.organizationExists)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }